import { lazy } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router";
import { selectAuth } from "store/auth-slice";

const VendorLayout = lazy(() => import("layouts/VendorLayout/VendorLayout"));
const BranchLayout = lazy(() => import("layouts/BranchLayout/BranchLayout"));
const CashierLayout = lazy(() => import("layouts/CashierLayout/CashierLayout"));

export default function ProtectedRoute({ children }) {
  const auth = useSelector(selectAuth);
  const navigate = useNavigate();

  const handleResetAll = () => {
    localStorage.clear();
    navigate("/login");
  };

  if (auth.token) {
    switch (auth.userRole) {
      case "vendor":
        return <VendorLayout />;

      case "branch":
        return <BranchLayout />;

      case "cashier":
        return <CashierLayout />;

      default:
        return (
          <div className="flex justify-center items-center h-screen w-full flex-col gap-5 text-xl">
            Something went wrong
            <button
              className="px-3 bg-orange-600 py-2  rounded-xl text-white"
              onClick={handleResetAll}
            >
              login again to solve it
            </button>
          </div>
        );
    }
  }

  return <Navigate to="/login" />;
}
